import axios from "axios";
import axiosInterceptor from './AxiosInterceptor';
import { makeSecureAPICall } from "./SignatureHelperFn";

// export const BaseUrl = ENVIRONMENTS[SELECTED_ENVIRONMENT].baseurl || "";
export const baseUrl = process.env.REACT_APP_BASE_API_URL;
export const idmUrl = process.env.REACT_APP_IDM_URL;

axiosInterceptor();

//to get geograpghy chart data (World Map)
export const getSurveyQuestions = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/survey-questions-library`, payload);
};